module.exports = Object.freeze({
    NONE: 0,
    DELETED: 1,
    UNREAD: 2,
    READ: 3,
    DONE: 4,
});
